import './About.css'

export default function About() {
    return (
        <div className="about" id='about'>
            <div className="content"><h1 className='about_heading'>ABOUT</h1>
            <div>
            SX Summit ATL is a celebration of innovation around the Atlanta area.<br></br><br></br>

Connect with notable startups around Atlanta, plus student entrepreneurs from Georgia Tech, GSU, Emory University, UGA, Spelman College, & Morehouse College. <br></br><br></br>

Then, hear from notable founders who detail their journey through entrepreneurship.<br></br><br></br>

After, hear pitches from each team part of the Startup Exchange incubator program, as they compete for cash prizes and demo their product to investor judges to showcase their team's hard work.

            </div></div>
            
        </div>
    )
}